import { get } from 'lodash'
import { required, emailOrPhoneRequired } from 'utils/validation'
import { SUBCATEGORIES } from 'constants/layout/setup-activity'
import { CONFIGURATION_KEYS } from 'constants/enums'
import { email } from '../../../../utils/validation'

const validate = (values, props) => {
  const isAssessorManagementEnabled = get(props, `configuration.values.${CONFIGURATION_KEYS.isAssessorManagementEnabled.id}.booleanValue`)

  const assessorMandatory = get(props, `configuration.values.${CONFIGURATION_KEYS.assessorMandatory.id}.booleanValue`)

  const errors = {
    helpers: {
      category: required(get(values, 'helpers.category')),
      subcategory: required(get(values, 'helpers.subcategory'))
    },
    activityCategory: {
      id: required(get(values, 'activityCategory.id'))
    },
    aim: required(get(values, 'aim')),
  }

  if (assessorMandatory && !isAssessorManagementEnabled) {
    const emailOrPhoneCheck = emailOrPhoneRequired(get(values, 'assessorEmail'), get(values, 'assessorPhone'))

    errors.assessorName = required(get(values, 'assessorName'))
    errors.assessorEmail = emailOrPhoneCheck
    errors.assessorPhone = emailOrPhoneCheck

  } else if(isAssessorManagementEnabled){

    const isNoneOfTheseSubCategory = get(values, 'setupAssessorId') === 0

    errors.setupAssessorId = required(get(values, 'setupAssessorId'))

    if (isNoneOfTheseSubCategory) {
      errors.assessorTitle = required(get(values, 'assessorTitle'))
      errors.assessorName = required(get(values, 'assessorName'))
      errors.assessorEmail =  required(get(values, 'assessorEmail')) || email(get(values, 'assessorEmail'))
      errors.assessorPhone = required(get(values, 'assessorPhone'))
      errors.assessorRelevantExperience = required(get(values, 'assessorRelevantExperience'))
    }
  }

  if (get(values, 'helpers.subcategory') === SUBCATEGORIES.others.value) {
    errors.helpers.others = required(get(values, 'helpers.others'))
  }

  return errors
}

export default validate
